module.exports = __webpack_public_path__ + "static/media/Big_time_gaming.539b0fd8.png";